import {ConnectException} from '../../../framework/message/ConnectException';

export class ApiResponse {
exception: ConnectException;
filename: string;
status: number | null;
}

